import { createSlice } from '@reduxjs/toolkit';

import actions from './subcatalogs.actions';
import subcatalogsAdapter from './subcatalogs.adapter';
import utils from './subcatalogs.utils';

import catalogs from 'domains/catalogs';

import type { LoadingStatus } from 'types/common_types';

const { fetchSubcatalogs } = actions;

type SubcatalogSliceInitialState = {
  status: LoadingStatus;
};

const initialState: SubcatalogSliceInitialState = {
  status: 'idle',
};

const slice = createSlice({
  name: 'subcatalogs',
  initialState: subcatalogsAdapter.getInitialState(initialState),
  reducers: {
    addMany: subcatalogsAdapter.addMany,
    reset: () => subcatalogsAdapter.getInitialState(initialState),
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSubcatalogs.pending, (state) => {
        return { ...state, status: 'loading' };
      })
      .addCase(fetchSubcatalogs.fulfilled, (state, { payload }) => {
        if (payload) {
          const { subcatalogs, catalogId } = payload;

          const update = subcatalogsAdapter.addMany(
            state,
            utils.flattenSubcatalogs(subcatalogs, catalogId)
          );

          update.status = 'idle';

          return update;
        } else {
          return { ...state, status: 'idle' };
        }
      })
      .addCase(fetchSubcatalogs.rejected, (state) => {
        // Handle an error, send more details to sentry, etc
        return { ...state, status: 'error' };
      })
      .addCase(catalogs.actions.getAllDeep.fulfilled, (state, { payload }) => {
        const subcatalogs = utils.flattenSubcatalogsFromCatalogs(payload);
        const update = subcatalogsAdapter.addMany(state, subcatalogs);

        return update;
      });
  },
});

export default slice;
